// extracted by mini-css-extract-plugin
export var container = "_u6-0";
export var table = "_u6-2";
export var tableWrapper = "_u6-1";